import {
  FieldRenderersMap,
  TableRenderersMap,
  SectionRenderersMap,
  SubsectionRenderersMap,
  appFieldRenderers,
  appTableRenderers,
  // appSectionRenderers,
  // appSubsectionRenderers,
} from '@shared/components/app-renderers';

import { SimulationResultTableComponent } from './tables/simulation-result/simulation-result-table.component';
import { DocumentsUploadTableComponent } from './tables/documents-upload/documents-upload-table.component';
import { CreditRequestsTableComponent } from './tables/credit-requests/credit-requests-table.component';
import { AppRequestTimelineTable } from './tables/request-timeline/request-timeline';
import { InsurancesTableComponent } from './tables/insurances/insurances-table.component';

export { FieldRenderersMap, TableRenderersMap, SectionRenderersMap, SubsectionRenderersMap };

export const creditFieldRenderers: FieldRenderersMap = {
  ...appFieldRenderers,
};

export const creditTableRenderers: TableRenderersMap = {
  ...appTableRenderers,
  simulationResult: SimulationResultTableComponent,
  documentsUpload: DocumentsUploadTableComponent,
  creditRequests: CreditRequestsTableComponent,
  requestTimeline: AppRequestTimelineTable,
  insurances: InsurancesTableComponent,
};

/*
export const creditSectionRenderers: SectionRenderersMap = {
  ...appSectionRenderers,
};

export const creditSubsectionRenderers: SubsectionRenderersMap = {
  ...appSubsectionRenderers,
};
*/
